module.exports = __webpack_public_path__ + "static/media/JSimage.37948fa3.png";